import Sortable from "sortablejs";

let sortingOrderList = document.querySelector('.sorting-order-wrapper');
if (sortingOrderList) {

    let sortingOrderInput = document.querySelector('#sorting_order');

    new Sortable(sortingOrderList, {
        sort: true,
        draggable: ".sorting-order-row",
        handle: ".sorting-order-handle",
        onEnd: function() {
            serializeOrder(sortingOrderList, sortingOrderInput);
        }
    });

}

function serializeOrder(list, input) {
    let order = Array.from(list.querySelectorAll('[data-sort-item-id]')).map((_) => _.getAttribute('data-sort-item-id'));
    input.value = order.join(',');
}